var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReports = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  clipPath: "url(#Reports_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.788 10.182c.892-.604 1.614-.68 2.167-.536 1.767.468 1.962 3.518 3.024 5.625M14.682 17.285q.104.01.22.008c3.4 0 4.249-4.248 5.098-7.647M4.443 12.629c-1.147 1.563-2.464 3.874-3.985 7.213"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.556 13.045a1.7 1.7 0 1 0 0-3.398 1.7 1.7 0 0 0 0 3.398M13.203 18.143a1.7 1.7 0 1 0 0-3.399 1.7 1.7 0 0 0 0 3.399M.458 2v19.542M20 21.542H.458"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Reports_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h22v22H0z"
})))));
export default SvgReports;